"use client";

import FilterDropdownFullScreen from "@/app/[locale]/buy-used-cars-uae/_components/FullScreenDialog";

interface ColorFilterDropdownFullScreenProps<T> {
  options: Array<{ value: T; label: string; hexCode?: string }>;
  id: string;
  helperText: string;
  withLabel?: boolean;
  onSelect: (option: any) => void;
  onClear?: () => void;
  value: { value: T; label: string; hexCode?: string } | Array<{ value: T; label: string; hexCode?: string }> | null;
  isLoading?: boolean;
  isSearchable?: boolean;
  isDisabled?: boolean;
  isMulti?: boolean;
  customNoOptionsMessage?: string;
}

export default function ColorFilterDropdownFullScreen<T>(props: ColorFilterDropdownFullScreenProps<T>) {
  return (
    <FilterDropdownFullScreen
      {...props}
      customOption={(option: any) => (
        <div className="flex items-center gap-2">
          {option.hexCode && (
            <span
              className="inline-block h-4 w-4 flex-shrink-0 rounded-full border border-gray-300"
              style={{ backgroundColor: option.hexCode }}
              aria-label={`${option.label} color`}
            />
          )}
          <span className="text-base font-medium">{option.label}</span>
        </div>
      )}
    />
  );
}
